import Raven from 'raven-js';
import I18n from 'I18n';
import { postAuthData } from './eventbriteApi';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const EventbriteServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const handleAuthSucceeded = code => {
    postAuthData(code).then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error on authentication of Eventbrite'
        }
      });
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: err,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed'),
        queryParams: new URLSearchParams(window.location.search).toString()
      });
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: url
  });
};